import React, { useEffect, useState } from "react"
import { Alert, TabContent, TabPane, NavItem, NavLink, Card, CardBody, CardHeader, FormGroup, Input, Label, Row, Col, Button } from "reactstrap"
import SpinnerWrap from "../Components/SpinnerWrap"
import classnames from "classnames"
import CreditsTable from "../Components/CreditsTable"
import countries from "../constants/countries.json"
import jwt from "jsonwebtoken"

const apiUrl = "https://balance.idexo.io"
const apiUrlUpdateOrg = "https://org.idexo.io/" // for updating user email/name/mobile/nationality/birthday
const apiUrlResetPW = "https://register.idexo.io/" // for resetting password

const Settings = () => {
    const [activeTab, setActiveTab] = useState("1")
    const [balanceData, setBalanceData] = useState(null)

    const [currentPassword, setCurrentPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")

    const [alertMessage, setAlertMessage] = useState("")
    const [alertColor, setAlertColor] = useState("")
    const [showSpinner, setShowSpinner] = useState(false)
    const decoded = jwt.decode(localStorage.jwtToken) // obj that contains email, type, user_id, paid, iat,

    // returns true if form is valid (i.e. form is NOT empty)
    const isValidForm = (form) => {
        if (!form) return false
        form = form.replace(/\s/g, "") // removes empty spaces
        return !!form
    }

    const allFormsValid = (forms) => {
        return forms.every((form) => isValidForm(form))
    }

    const handleSubmit = async (e, apiUrl, formData, method, action) => {
        e.preventDefault()
        setAlertMessage("")
        setShowSpinner(true)

        try {
            let res = await fetch(apiUrl, {
                method: method,
                headers: {
                    "Content-Type": "application/json",
                    token: localStorage.jwtToken
                },
                body: JSON.stringify({
                    ...formData,
                    action: action
                }),
                json: true
            })

            const dataRes = await res.json()
            console.log(dataRes)

            if (dataRes.error) {
                setAlertColor("danger")
                setAlertMessage(`Error: ${dataRes.error}`)
            } else {
                setAlertColor("success")
                let alertMessage =
                    action == "resetPassword"
                        ? "Password reset submitted. Check your email to complete the password reset"
                        : "Successfully updated user profile!"
                setAlertMessage(alertMessage)
                setCurrentPassword("")
                setNewPassword("")
                setConfirmPassword("")
            }
        } catch (err) {
            console.log(err)
            // setAlertMessage(err)
        }
        setShowSpinner(false)
    }

    useEffect(() => {
        if (!localStorage.jwtToken) return
        fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            json: true
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    alert("Error: " + data.error)
                } else {
                    if (data.data && data.data.balance) {
                        setBalanceData(data.data)
                    }
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    return (
        <React.Fragment>
            <div className="content">
                <div className="account-settings">
                    <Card>
                        <CardHeader className="bg-transparent border-bottom">
                            <ul className="nav nav-tabs nav-tabs-custom card-header-tabs ms-auto" role="tablist">
                                <NavItem>
                                    <NavLink
                                        to="#"
                                        className={classnames({
                                            active: activeTab === "1"
                                        })}
                                        onClick={() => {
                                            setActiveTab("1")
                                        }}
                                    >
                                        Balance
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        to="#"
                                        className={classnames({
                                            active: activeTab === "2"
                                        })}
                                        onClick={() => {
                                            setActiveTab("2")
                                        }}
                                    >
                                        Personal Data
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        to="#"
                                        className={classnames({
                                            active: activeTab === "3"
                                        })}
                                        onClick={() => {
                                            setActiveTab("3")
                                        }}
                                    >
                                        Password
                                    </NavLink>
                                </NavItem>
                            </ul>
                        </CardHeader>
                        <CardBody>
                            <TabContent activeTab={activeTab}>
                                <TabPane className="show" tabId="1">
                                    <div className="balance-info">
                                        <h4 className="mt-0 mb-1 font-size-14">idexo CREDITS</h4>
                                        <p className="mb-0 font-size-16">
                                            <span>{balanceData ? balanceData.balance : 0}</span> credits
                                        </p>
                                    </div>
                                    {balanceData && balanceData.history && <CreditsTable data={balanceData.history} />}
                                </TabPane>
                                <TabPane className="show" tabId="2">
                                    <Row>
                                        <Col md={12} lg={4}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="full-name" className="form-label">
                                                    Full Name
                                                </Label>
                                                <Input type="text" className="form-control" id="full-name" placeholder="Full Name" />
                                            </FormGroup>
                                        </Col>
                                        <Col md={12} lg={4}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="email" className="form-label">
                                                    Email Address
                                                </Label>
                                                <Input type="email" className="form-control" id="email" placeholder="Email" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12} lg={4}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="mobile-number" className="form-label">
                                                    Mobile Number
                                                </Label>
                                                <Input type="tel" className="form-control" id="mobile-number" placeholder="Mobile Number" />
                                            </FormGroup>
                                        </Col>
                                        <Col md={12} lg={4}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="birthday" className="form-label">
                                                    Date of Birth
                                                </Label>
                                                <Input type="date" className="form-control" id="birthday" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12} lg={4}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="country" className="form-label">
                                                    Nationality
                                                </Label>
                                                <select className="form-select">
                                                    <option key="" disabled selected>
                                                        Select Nationality
                                                    </option>
                                                    {countries && countries.map((country) => <option key={country.name}>{country.name}</option>)}
                                                </select>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Button color="primary" className="waves-effect" onClick={() => {}}>
                                        Update Profile
                                    </Button>
                                </TabPane>
                                <TabPane className="show" tabId="3">
                                    <Row>
                                        <Col md={12} lg={8}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="old-password" className="form-label">
                                                    Current Password
                                                </Label>
                                                <Input
                                                    type="password"
                                                    className="form-control"
                                                    id="old-password"
                                                    placeholder="Current Password"
                                                    value={currentPassword}
                                                    disabled={showSpinner}
                                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={12} lg={8}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="new-password" className="form-label">
                                                    New Password
                                                </Label>
                                                <Input
                                                    type="password"
                                                    className="form-control"
                                                    id="new-password"
                                                    placeholder="New Password"
                                                    value={newPassword}
                                                    disabled={showSpinner}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={12} lg={8}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="confirm-password" className="form-label">
                                                    Confirm Password
                                                </Label>
                                                <Input
                                                    type="password"
                                                    className="form-control"
                                                    id="confirm-password"
                                                    placeholder="Confirm Password"
                                                    value={confirmPassword}
                                                    disabled={showSpinner}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Button
                                        color="primary"
                                        className="waves-effect w-xl me-3 reset-password-btn"
                                        type="submit"
                                        disabled={showSpinner || !allFormsValid([newPassword, currentPassword, confirmPassword])}
                                        onClick={(e) =>
                                            handleSubmit(e, apiUrlResetPW, { email: decoded.email, password: newPassword }, "PATCH", "resetPassword")
                                        }
                                    >
                                        <SpinnerWrap showSpinner={showSpinner} txtTrue={"Resetting Password"} txtFalse={"Reset Password"} />
                                    </Button>
                                    {alertMessage ? <Alert color={alertColor}>{alertMessage}</Alert> : null}
                                </TabPane>
                            </TabContent>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Settings
